import {
    handleActions,
    Action,
} from 'redux-actions';
import moment from 'moment';
import {
    QC_TOOLS_PUBLISHING_RIGHTS_SET,
    PublishingRightsPayload,
    QC_TOOLS_PUBLISHING_RIGHTS_RESET,
} from './QCToolsPublishingRightsActions';
import {PublishingRightsState, PublishingRights} from '../QCToolsPublishingRightsTypes';

type QCToolsPublishingRightsAction = Action<PublishingRightsPayload>;

export const mapRights = (right: PublishingRights) => ({
    ...right,
    availabilityStart: moment(right.availabilityStart).utc().format('L [at] LT'),
    availabilityEnd: moment(right.availabilityEnd).utc().format('L [at] LT'),
});

export const setQCToolsPublishingRights = (state: PublishingRightsState, action: QCToolsPublishingRightsAction): PublishingRightsState => {
    if (action.error) {
        return initialState;
    }
    
    const {payload: {contentItem: {publishingRights}}} = action;
    const rights = publishingRights.map(mapRights);
    
    return {
        publishingRights: rights,
        isLoading: false,
    };
};

export const resetQCToolsPublishingRights = () => initialState;

export const initialState = {
    publishingRights: [],
    isLoading: true,
};

const handlers = {
    [QC_TOOLS_PUBLISHING_RIGHTS_SET]: setQCToolsPublishingRights,
    [QC_TOOLS_PUBLISHING_RIGHTS_RESET]: resetQCToolsPublishingRights,
};

export default handleActions(handlers, initialState);
